import {observer} from "mobx-react";
import React from "react";
import {
    ContentPermission, ContentDataInput, ContentInput
} from "./styled";
import InputWithBorder from "@dropDesk/presentation/components/inputs/input_with_border";
import {
    useValidatorInputPanelAdm
} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/input_search/validator";


const InputsPanelAdm = observer(
    ({
         getCompany,
         onUpdate,
         search,
         loading
     }: {
        getCompany: () => Promise<void>,
        onUpdate: (search: string) => void,
        search?: string
        loading: boolean
    }) => {

        const {errorMessageSearch, isValidDataForm} = useValidatorInputPanelAdm(search);

        return (
            <ContentPermission>
                <ContentDataInput>
                    <ContentInput>
                        <InputWithBorder
                            autoFocus={true}
                            required={true}
                            name='search'
                            size={35}
                            disabled={loading}
                            useButtonRight={true}
                            onClickButtonRight={() => getCompany()}
                            labelButtonRight={'Buscar'}
                            disabledButtonRight={loading || !isValidDataForm}
                            messageError={errorMessageSearch}
                            label={"Código de referência / CNPJ"}
                            value={search ? search.toString() : ''}
                            onChange={(event) => onUpdate(event.target.value)}
                        />
                    </ContentInput>
                </ContentDataInput>
            </ContentPermission>
        )
    })
export default InputsPanelAdm;
